import {logger} from "@/components/DownloaderApp/logger";

export function calculateThumbnail(props) {
    const {
        durationInMs,
        pointerPosition,
        playbackUrl,
        playbackThumbnailUrl,
        thumbnailWidth,
        thumbnailHeight,
    } = props;

    logger.log(props)

    const durationSec = durationInMs / 1000;

    // Which thumbnail sprite sheet index
    const sheetIndex = Math.floor(pointerPosition / 15000);

    // Number of rows in current sheet
    const totalSheets = Math.ceil(durationSec / 15000);
    const framesPerColumn =
        totalSheets === sheetIndex + 1
            ? Math.ceil((durationSec % 15000) / 300)
            : 50;

    // Position inside sprite sheet
    const positionInSheet = (pointerPosition % 15000) / 60;

    const column = Math.floor(positionInSheet % 5);
    const row = Math.floor(positionInSheet / 5) % framesPerColumn;

    let xOffset = -(column * thumbnailWidth);
    let yOffset = -(row * thumbnailHeight);

    const maxColumn = Math.floor((durationSec % 15000 % 300) / 60);

    // Edge case correction for last row
    if (row === framesPerColumn - 1 && column >= maxColumn) {
        xOffset = -((maxColumn - 1) * thumbnailWidth);
    }

    // Resolve thumbnail URL
    let resolvedUrl = null;
    if (playbackThumbnailUrl?.trim()) {
        resolvedUrl = playbackThumbnailUrl.replace("{{chunk_no}}", String(sheetIndex));
    } else {
        resolvedUrl = playbackUrl.replace(
            "media/hls/master.m3u8",
            `media/thumbnails/thumbnail-sheet-${sheetIndex}.webp`
        );
    }

    return {
        url: resolvedUrl,
        xOffset,
        yOffset,
    };

}
